<template>
	<div class="favorite" @click.prevent="toggle()">
		<span class="label">Favorit</span>
		<transition name="bounce" mode="out-in">
			<i v-if="favorite" class="fas fa-heart fa-fw" key="on"></i>
			<i v-if="!favorite" class="far fa-heart fa-fw" key="off"></i>
		</transition>
	</div>
</template>

<script>
export default {
	props: ["id", "type"],
	data() {
		return {
			key: `favorite.${this.type}:${this.id}`,
			get favorite() {
				return localStorage.getItem(this.key) || false;
			},
			set favorite(value) {
				if (value) {
					localStorage.setItem(this.key, true)
				} else {
					localStorage.removeItem(this.key);
				}
			},
		}
	},
	methods: {
		toggle() {
			if (localStorage.getItem(this.key)) {
				this.favorite = false;
			} else {
				this.favorite = true;
			}
		}
	},
}
</script>